var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutHandoffExpired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 120,
    viewBox: "0 0 97 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.38 65.1935L6.56 41.3535L2 43.9535L20.38 75.6435L24.93 73.0435L20.38 65.1935Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2203 66.5935L71.9603 67.3135L58.1403 75.1935L57.1203 75.7735L52.5703 67.9235L53.5903 67.3435L58.2203 64.7035L62.7703 62.1035L67.4003 59.4535L68.5003 58.8335L73.2203 66.5935Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8498 55.8035L53.5098 56.5635L48.8698 59.2035L47.8498 59.7835L43.2998 51.9335L44.3198 51.3535L48.9498 48.7135L50.2898 47.9535L54.8498 55.8035Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 56.5935L76.61 64.8935L73.22 66.5935L68.5 58.8335L88.5 48.8335L93.22 56.5935Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8501 45.8035L67.8501 49.7835L63.1601 52.1335L58.3801 54.5235L53.6801 56.8635L48.9001 59.2535L48.8701 59.2035L53.5101 56.5635L54.8501 55.8035L58.1601 54.1435L62.9401 51.7535L67.6301 49.4135L74.8501 45.8035Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0304 115.383L69.4804 117.983L48.0204 80.9635L38.7504 86.2435L29.8604 70.9035L29.7104 70.6535L20.3804 54.5535L24.9304 51.7735L34.4904 68.2635L34.6404 68.5135L38.7504 75.6135L43.3004 73.0135L39.3304 66.1635L39.1904 65.9135L29.6304 49.4235L20.8204 34.2235L9.65039 14.9635L14.2004 12.1835L25.5904 31.8335L25.6204 31.8835L34.4104 47.0335L43.9704 63.5235L44.0004 63.5735L74.0304 115.383Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7096 70.6535L24.9296 73.0435L20.3796 65.1935L6.55957 41.3535L20.8196 34.2235L29.6296 49.4235L24.9296 51.7735L20.3796 54.5535L29.7096 70.6535Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2997 73.0135L38.7497 75.6135L34.6397 68.5135L34.4897 68.2635L24.9297 51.7735L29.6297 49.4235L39.1897 65.9135L39.3297 66.1635L43.2997 73.0135Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8599 70.9035L20.3799 75.6435",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2201 56.5935L77.1201 65.7735L72.4301 68.1235L58.1701 75.2435L57.1201 75.7735L58.1401 75.1935L71.9601 67.3135L73.2201 66.5935L76.6101 64.8935L93.2201 56.5935Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.85 45.8035L67.63 49.4135L62.94 51.7535L58.16 54.1435L54.85 55.8035L50.29 47.9535L53.61 46.2935L58.39 43.9035L70.29 37.9535L74.85 45.8035Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0302 105.383L89.3302 107.733L74.0302 115.383L44.0002 63.5735L43.9702 63.5235L34.4102 47.0335L25.6202 31.8835L25.5902 31.8335L14.2002 12.1835L34.2002 2.18347L58.3902 43.9035L53.6102 46.2935L50.2902 47.9535L48.9502 48.7135L44.3202 51.3535L43.3002 51.9335L47.8502 59.7835L48.9002 59.2535L53.6802 56.8635L58.3802 54.5235L63.1602 52.1335L67.4002 59.4535L62.7702 62.1035L58.2202 64.7035L53.5902 67.3435L52.5702 67.9235L57.1202 75.7735L58.1702 75.2435L72.4302 68.1235L94.0302 105.383Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0305 105.383L89.4805 107.983L69.4805 117.983L74.0305 115.383L89.3305 107.733L94.0305 105.383Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutHandoffExpired);
export default __webpack_public_path__ + "static/media/checkout-handoff-expired.2548d16b4219dd48d852f6fac96b9422.svg";
export { ForwardRef as ReactComponent };